// src/hocs/withOutsideClick.js
import React, { useEffect, useRef } from "react";

const withOutsideClick = (WrappedComponent) => {
  const WithOutsideClick = (props) => {
    const ref = useRef(null); // Ref for the DOM element
    const componentRef = useRef(null); // Ref for the component instance

    useEffect(() => {
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          // Check if the component has a handleClickOutside method
          if (componentRef.current && typeof componentRef.current.handleClickOutside === "function") {
            componentRef.current.handleClickOutside();
          }
        }
      }

      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, []); // Empty dependency array since componentRef is stable

    return (
      <div ref={ref}>
        <WrappedComponent {...props} ref={componentRef} />
      </div>
    );
  };

  // Set display name for debugging
  WithOutsideClick.displayName = `WithOutsideClick(${WrappedComponent.displayName || WrappedComponent.name || "Component"})`;

  return WithOutsideClick;
};

export default withOutsideClick;
